<template>
  <div class="home">
    <div class="top">
      <div class="shang">
        <div class="logo">
          <img src="../assets/logo@2x.png" alt="" />
          <div>
            <div>推动资源共享 &nbsp; &nbsp; &nbsp;服务科技创新</div>
            <!-- <div></div> -->
          </div>
        </div>

        <div class="tiaoz" v-if="this.token == null">
          <!-- <div class="zuo" @click="tiao(9)" >
            个人中心
          </div> -->
          <div class="zuo" @click="tiao(19)">登录</div>
          <div class="you" @click="tiao(10)">注册</div>
        </div>
        <div class="tiaoz" v-if="this.token !== null">
          <div class="zuo" @click="tiao(9)">个人中心</div>
          <div class="zuo">
            <a :href="basePathUrl" target="blank"> 进入管理系统</a>
          </div>
          <div class="you" @click="tiao(20)">退出登录</div>
        </div>
      </div>
      <div class="biaoti">
        <div>深圳市重大科技基础设施和大型科研仪器共享平台</div>
      </div>
      <div class="taiojian">
        <img src="../assets/huo.png" alt="" />
        <p>热门搜索：</p>
        <!-- <span @click="search(1)"> 色谱仪</span>
        <span @click="search(2)"> 核磁</span>
        <span @click="search(3)"> 显微镜</span>
        <span @click="search(4)"> 分析仪</span> -->
        <span @click="search(1)"> 分析仪器</span>
        <span @click="search(2)"> 核磁</span>
        <span @click="search(3)"> 显微镜</span>
        <span @click="search(4)"> 计算机</span>
        <span @click="search(5)"> 有机化学</span>
        <!-- 热门搜索：                           -->
        <!-- <span @click="search(5)"> 有机化学</span> -->
      </div>
      <div class="sousuo">
        <div class="ssdi">
          <div class="search">
            <div class="xiala">
              <el-select v-model="xiala" placeholder="仪器" :key="this.num">
                <el-option label="仪器" value="仪器"></el-option>
                <el-option label="公告" value="公告"></el-option>
                <el-option label="新闻" value="新闻"></el-option>
                <el-option label="政策" value="政策"></el-option>
              </el-select>
            </div>

            <div class="shu"></div>
            <input
              v-model="tit"
              class="inp"
              type="text"
              name=""
              id=""
              placeholder="输入关键词 "
            />
            <div class="anniu" @click="search">
              <img src="../assets//se.png" alt="" />
              <!-- <i class="el-input__icon el-icon-search"></i> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="zhong">
        <div>
          <div class="rou">
            <div class="shu">{{ this.yiqi.singleNum }}</div>
            <div class="zhi">仪器数量（台套）</div>
          </div>

          <img src="../assets/zhong1.png" alt="" />
        </div>
        <div>
          <div class="rou">
            <div class="shu">{{ this.yiqi.insNum }}</div>
            <div class="zhi">管理单位（家）</div>
          </div>

          <img src="../assets/zhong2.png" alt="" />
        </div>

        <div>
          <div class="rou">
            <div class="shu">{{ this.yiqi.singleWorth }}</div>
            <div class="zhi">仪器原值（亿）</div>
          </div>

          <img src="../assets/zhong3.png" alt="" />
        </div>
        <div>
          <div class="rou">
            <div class="shu">{{ this.yiqi.pxNum }}</div>
            <div class="zhi">培训人才（人）</div>
          </div>

          <img src="../assets/zhong4.png" alt="" />
        </div>
      </div> -->
      <!-- <div class="zhanshi">
        <div class="kuai">
          <img src="../assets/zhanshi (1).png" alt="" />
          <div class="kuaizi">
            <div class="zishang">515</div>
            <div class="zixia">单位数量（家）</div>
          </div>
        </div>
        <div class="kuai">
          <img src="../assets/zhanshi (2).png" alt="" />
          <div class="kuaizi">
            <div class="zishang">8781</div>
            <div class="zixia">仪器总数（台套）</div>
          </div>
        </div>
  
        <div class="kuai">
          <img src="../assets/zhanshi (3).png" alt="" />
          <div class="kuaizi">
            <div class="zishang">284.5</div>
            <div class="zixia">仪器原值（亿元）</div>
          </div>
        </div>
 
      </div> -->
    </div>
    <!-- <div class="tongzi">
      <div class="tongle">
        <span>通知 公告</span>
        <img src="../assets/tongz.png" alt="" />
      </div>
      <div class="tongri">
        <div
          class="ritop"
          v-for="(item, i) in tong.slice(0, 1)"
          :key="i"
          @click="tzdome(item)"
        >
          {{ item.title }}
        </div>
        <div class="ribot">
          <div
            v-for="(item, i) in tong.slice(1, 4)"
            :key="i"
            @click="tzdome(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="tongimg" @click="tiao(7)">
        <img src="../assets/xwjian.png" alt="" />
      </div>
    </div> -->
    <div class="daohang">
      <span class="xian"><span>首页</span></span>
      <span @click="tiao(2)">资讯动态</span>
      <span @click="tiao(5)">政策法规</span>
      <span @click="tiao(6)">办事大厅</span>

      <span @click="tiao(3)">仪器共享</span>
      <span @click="tiao(8)">重大设施</span>
      <!-- <span @click="tiao(4)">在线平台</span> -->
      <span @click="tiao(7)">科技资源</span>
      <span @click="tiao(12)">关于平台</span>
    </div>
    <div class="main">
      <div class="lunbo">
        <el-carousel :interval="5000" arrow="never" ref="qiehuan" lable="">
          <el-carousel-item v-for="(item, i) in lunbo" :key="i">
            <img :src="item.imgurl" @click="xwdome(item, i)" alt="" />
            <div class="lundi">
              <div class="lunzi">{{ item.title }}</div>
              <div class="lunzuo" @click="qie(1)">《</div>
              <div class="lunjing">{{ i + 1 }}/5</div>
              <div class="lunyou" @click="qie(2)">》</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="xw">
        <div class="xwtit">
          <img class="titd" src="../assets/biaodian.png" alt="" />
          <span class="dian2" @click="dian(2)"> 通知公告</span>
          &nbsp;
          <span class="dian1" @click="dian(1)">新闻资讯 </span>
          <img
            v-if="this.b == 1"
            @click="tiao(2)"
            class="titt"
            src="../assets/xwjian.png"
            alt=""
          />
          <img
            v-if="this.b == 2"
            @click="tiao(0)"
            class="titt"
            src="../assets/xwjian.png"
            alt=""
          />
        </div>
        <div v-if="this.b == 1">
          <div class="xwlie" v-for="(item, i) in this.xw" :key="i">
            <div class="xwtime">
              <div class="ri">{{ item.ri }}</div>
              <div class="yue">{{ item.yue }} <span>月</span></div>
            </div>
            <div class="xwxian">
              <div class="xwxiany">⚪</div>
              <div class="xwxianx"></div>
            </div>
            <div class="xwbiao" @click="xwdome(item, i)">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top-start"
              >
                <div class="xwbaiotit">{{ item.title }}</div>
              </el-tooltip>

              <!-- <div class="xwbaionei" v-html="item.excerpt"></div> -->
            </div>
          </div>
        </div>
        <div v-if="this.b == 2">
          <div class="xwlie" v-for="(item, i) in this.tong" :key="i">
            <div class="xwtime">
              <div class="ri">{{ item.ri }}</div>
              <div class="yue">{{ item.yue }} <span>月</span></div>
            </div>
            <div class="xwxian">
              <div class="xwxiany">⚪</div>
              <div class="xwxianx"></div>
            </div>
            <div class="xwbiao" @click="tzdome(item)">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top-start"
              >
                <div class="xwbaiotit">{{ item.title }}</div>
              </el-tooltip>
              <!-- <div class="xwbaionei" v-html="item.excerpt"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="yewu">
      <div class="left">
        <div class="yewuxia">
          <a :href="basePathUrl" target="blank">
            <div>
              <img src="../assets/yewu (9).png" alt="" />
              <p>仪器上报</p>
            </div>
          </a>

          <div @click="tiao(6)">
            <img src="../assets/yewu (10).png" alt="" />
            <p>年度统计</p>
          </div>
          <div @click="jians">
            <img src="../assets/yewu (11).png" alt="" />
            <p>仪器查重</p>
          </div>
        </div>

        <div class="yewuxia">
          <div @click="jians">
            <img src="../assets/yewu (12).png" alt="" />
            <p>联合评议</p>
          </div>
          <div @click="tiao(6)">
            <img src="../assets/yewu (13).png" alt="" />
            <p>考核评价</p>
          </div>
          <div @click="tiao(6)">
            <img src="../assets/yewu (14).png" alt="" />
            <p>海关监管</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="lianle">
          <div class="lianletop">
            <img class="lianled" src="../assets/biaodian.png" alt="" />
            <span>政策法规</span>
            <img
              @click="tiao(5)"
              class="lianlet"
              src="../assets/xwjian.png"
              alt=""
            />
          </div>
          <div class="zhengc" v-for="(item, i) in ze" :key="i">
            <span></span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.regName"
              placement="top-start"
            >
              <a @click="xiang(item, i)" target="_blank">
                {{ item.regName }}
              </a>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="yiqi">
      <div class="juz">
        <div class="yitop">
          <img class="lianled" src="../assets/biaodian.png" alt="" />
          <span>仪器共享</span>
          <span class="yyy" @click="tiao(3)">更多</span>
        </div>
      </div>
      <div class="yilie">
        <div class="yizuo">
          <div class="yu" @click="tiao(3)">预约仪器</div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="所属分类" name="11">
              <div
                v-for="(option, i) in phoneData1"
                @click="lei(option.mainName)"
              >
                {{ option.mainName }}
              </div>
            </el-collapse-item>
            <el-collapse-item title="学科领域" name="22">
              <div
                v-for="(option, i) in phoneData2"
                @click="xue(option.disciplineField)"
              >
                {{ option.disciplineField }}
              </div>
            </el-collapse-item>
            <el-collapse-item title="产业领域" name="33">
              <div
                v-for="(option, i) in phoneData3"
                @click="chan(option.industrye)"
              >
                {{ option.industrye }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="yiyou">
          <div class="yous">
            <div
              class="youge"
              v-for="(option, i) in copybasic"
              @click="xiangqing(option)"
            >
              <img :src="option.image" alt="" />
              <div class="name">{{ option.cname }}</div>
              <div class="xing">型号:{{ option.instrVersion }}</div>
              <div class="lei">类型:{{ option.mainName }}</div>
              <div class="biao">
                <i class="el-icon-location-outline"></i>
                <span>{{ option.name }} </span>
              </div>
            </div>
          </div>
          <!-- <div class="youx" @click="tiao(3)">
            仪器预约 <i class="el-icon-right"></i>
          </div> -->
        </div>
      </div>
    </div>

    <div class="shes">
      <div class="juz">
        <div class="shestop">
          <img class="shesled" src="../assets/biaodian.png" alt="" />
          <span>重大科技基础设施</span>
        </div>
        <div class="sheslie">
          <lunbo :images="shesi"></lunbo>
          <!-- <div class="hang">
            <div class="ge">
              <a href="https://cloudbrain.pcl.ac.cn/" target="_blank">
                <img src="../assets/she (1).png" alt="" />

                <div>鹏城云脑”网络智能重大科技基础设施</div>
              </a>
            </div>
            <div class="ge">
              <a href="https://www.nsccsz.cn/" target="_blank">
                <img src="../assets/she (2).png" alt="" />

                <div>国家超级计算深圳中心二期</div>
              </a>
            </div>
            <div class="ge">
              <a href="https://isynbio.siat.ac.cn/" target="_blank">
                <img src="../assets/she (3).png" alt="" />

                <div>合成生物研究设施</div>
              </a>
            </div>
          </div>
          <div class="hang">
            <div class="ge">
              <a href="http://bcbdi.siat.ac.cn/" target="_blank">
                <img src="../assets/she (4).png" alt="" />

                <div>脑解析与脑膜拟设施</div>
              </a>
            </div>
            <div class="ge">
              <a
                href="https://www.szgm.gov.cn/xxgk/kxc/kjcxzy/"
                target="_blank"
              >
                <img src="../assets/she (5).png" alt="" />

                <div>精准医学影像大设施</div>
              </a>
            </div>
            <div class="ge">
              <a
                href="https://www.szgm.gov.cn/xxgk/kxc/kjcxzy/"
                target="_blank"
              >
                <img src="../assets/she (6).png" alt="" />

                <div>材料基因组设施</div>
              </a>
            </div>
          </div>
          <div class="hang">
            <div class="ge">
              <a
                href="https://www.szgm.gov.cn/xxgk/kxc/kjcxzy/"
                target="_blank"
              >
                <img src="../assets/she (7).png" alt="" />

                <div>特殊环境材料器件科学与应用研究设施</div>
              </a>
            </div>
            <div class="ge">
              <a href="https://www.bgi.com/" target="_blank">
                <img src="../assets/she (8).png" alt="" />

                <div>华大基因库</div>
              </a>
            </div>
            <div class="ge">
              <a href="https://cryoem.sustech.edu.cn/" target="_blank">
                <img src="../assets/she (9).png" alt="" />

                <div>冷冻电镜中心</div>
              </a>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="zaixian">
      <div class="juz">
        <div class="zaitop">
          <img class="lianled" src="../assets/biaodian.png" alt="" />
          <span>科技资源</span>
        </div>
        <div class="zailie">
          <div class="rrr" @click="ping(0)">
            <a target="_blank">
              <img src="../assets/ke (1).png" alt="" />
              <div class="zainame">在线平台</div>
            </a>
          </div>
          <div class="rrr" @click="ping(1)">
            <a target="_blank">
              <img src="../assets/ke (5).png" alt="" />
              <div class="zainame">分析测试平台</div>
            </a>
          </div>
          <div class="rrr" @click="ping(2)">
            <a target="_blank">
              <img src="../assets/ke (4).png" alt="" />
              <div class="zainame">动物实验中心</div>
            </a>
          </div>
          <div class="rrr" @click="ping(3)">
            <a target="_blank">
              <img src="../assets/ke (3).png" alt="" />
              <div class="zainame">算力平台</div>
            </a>
          </div>
          <div class="rrr" @click="ping(4)">
            <a target="_blank">
              <img src="../assets/ke (2).png" alt="" />
              <div class="zainame">冷冻电镜中心</div>
            </a>
          </div>
          <div class="rrr" @click="ping(5)">
            <a target="_blank">
              <img src="../assets/ke (6).png" alt="" />
              <div class="zainame2">微纳加工测试平台</div>
            </a>
          </div>
          <div class="zaitaio" @click="tiao(7)">点击查看更多科技资源...</div>
        </div>
      </div>
    </div>
    <!-- <div class="lianjie">
      <div class="lianrig">
        <div class="lianrigtop">
          <img class="lianrigd" src="../assets/biaodian.png" alt="" />
          <span>友情链接</span>
       
        </div>
        <div class="youlie">
          <div class="yyy" v-for="(item, i) in youq" :key="i">
            <a :href="item.linkAddress" target="_blank">
              <img :src="item.imgurl" alt="" />
              <div class="youzi">{{ item.title }}</div>
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 跳转到一期的飘窗 -->
    <!-- <div class="piao" v-if="p" @click="wai()">
      <div @click="ying()"></div>
    </div> -->
    <footh></footh>
  </div>
</template>

<script>
// @ is an alias to /src
import top from "@/components/top.vue";
import footh from "@/components/footh.vue";
// import Vfooth from "@/components/footh.vue";
import lunbo from "./lunbo.vue";
import {
  news,
  lation,
  lationWeb,
  shoushu,
  xx,
  denglu,
  nriiauth,
  userInfoGet,
  basePathUrl,
  fenlei,
  xueke,
  linyu,
  yiqi,
} from "@/api/index";
import qs from "qs";

export default {
  name: "HomeView",
  components: {
    top,
    footh,
    lunbo,
  },
  data() {
    return {
      num: "1",
      xiala: "",
      tit: "",
      chus: "",
      copybasic: {},
      lunbo: {},
      xw: {},
      ze: {},
      tong: {},
      token: "",
      b: 2,
      yiqi: {},
      pingtai: {},
      youq: {},
      userid: "",
      id: "",
      re: "",
      basePathUrl: "",
      activeName: "11",
      phoneData1: [],
      phoneData2: [],
      phoneData3: [],
      xueguan: [],
      copybasic: [],
      p: true,
      shesi: [
        {
          mc: "“鹏城云脑Ⅱ扩展型”重大科技基础设施",

          imgurl: require("../assets/she (1).png"),
        },
        {
          mc: "国家超级计算深圳中心",

          imgurl: require("../assets/she (2).png"),
        },
        {
          mc: "合成生物研究重大科技基础设施",

          imgurl: require("../assets/she (3).png"),
        },
        {
          mc: "脑解析与脑模拟重大科技基础设施",

          imgurl: require("../assets/she (4).png"),
        },
        // {
        //   mc: "精准医学影像大设施",

        //   imgurl: require("../assets/she (5).png"),
        // },
        // {
        //   mc: "特殊环境材料器件科学与应用研究设施",

        //   imgurl: require("../assets/she (7).png"),
        // },
        {
          mc: "深圳国家基因库",

          imgurl: require("../assets/she (8).png"),
        },
        {
          mc: "材料基因组大科学装置平台重大科技基础设施",

          imgurl: require("../assets/she (10).png"),
        },
        // {
        //   mc: "冷冻电镜中心",

        //   imgurl: require("../assets/she (9).png"),
        // },
      ],
    };
  },
  async mounted() {
    this.denglu();
    const token = sessionStorage.getItem("token");
    this.token = token;
    if (!this.token) {
      const accessToken = JSON.parse(localStorage.getItem("ACCESS_TOKEN"));
      const refreshToken = JSON.parse(localStorage.getItem("REFRESH_TOKEN"));
      this.token = accessToken.v;
      sessionStorage.setItem("retoken", refreshToken.v);
    }

    const id = sessionStorage.getItem("id");
    if (id !== null && token !== null) {
      this.id = id;
    }
    if (id == null) {
      this.id = null;
    }
    if (token !== null) {
      let a = await xx(token);

      this.userid = a.data.data.id;
    }
    // this.basePathUrl = basePathUrl() + "/v2_admin";
    this.basePathUrl = "https://irshare.cn/v2_admin";
  },
  methods: {
    denglu() {
      this.content();
      if (this.userid !== "") {
        denglu(this.userid).then((res) => {
          if (res.status == 200) {
            let dl = res.data.data;
            ////console.log(dl);
          }
        });
      }
    },
    search(id) {
      if (id == 1) {
        this.tit = "分析仪器";
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }
      if (id == 2) {
        this.tit = "核磁";
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }
      if (id == 3) {
        this.tit = "显微镜";
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }
      if (id == 4) {
        this.tit = "计算机";
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }
      if (id == 5) {
        this.tit = "有机化学";
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }
      if (this.tit == "") {
        this.$message.warning("请您输入想搜索的内容");
        return;
      }
      // ////console.log(this.xiala, "1111111111");
      // ////console.log(this.tit, "22222222222222222");
      if (this.xiala == "" || this.tit !== "") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }
      if (this.xiala == "仪器") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "yiqiliebiao", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      }

      if (this.xiala == "新闻") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "news", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(2));
      }

      if (this.xiala == "政策") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "evalist", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(5));
      }
      if (this.xiala == "公告") {
        this.$emit("childEvent", this.tit);
        this.$router.push({ name: "noticelie", params: { tit: this.tit } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(0));
      }
    },
    tiao(index) {
      this.num = index;
      this.num = JSON.parse(this.num);
      // ////console.log(this.num);
      sessionStorage.setItem("insuranceCode", JSON.stringify(this.num));
      if (index == 0) {
        sessionStorage.setItem("insuranceCode", JSON.stringify(2));
        this.$router.push("/noticelie");
        document.documentElement.scrollTop = 0;
      }
      if (index == 1) {
        this.chus = index;
        this.$router.push("/");
        document.documentElement.scrollTop = 0;
      }
      if (index == 2) {
        this.$router.push("/news");

        document.documentElement.scrollTop = 0;
      }
      if (index == 3) {
        this.$router.push("/yiqiliebiao");
        document.documentElement.scrollTop = 0;
      }
      if (index == 4) {
        this.$router.push("/pingtai");
        sessionStorage.setItem("insuranceCode", JSON.stringify(4));
        document.documentElement.scrollTop = 0;
      }
      if (index == 5) {
        this.$router.push("/evalist");

        document.documentElement.scrollTop = 0;
      }
      if (index == 6) {
        this.$router.push("/banshi");

        document.documentElement.scrollTop = 0;
      }
      if (index == 7) {
        //this.$router.push("/fence");
        this.$router.push("/pingtai");

        document.documentElement.scrollTop = 0;
      }
      if (index == 8) {
        this.$router.push("/sheshi");

        document.documentElement.scrollTop = 0;
      }
      // if (index == 6) {
      //   this.$router.push("/policies");

      //   document.documentElement.scrollTop = 0;
      // }
      // if (index == 7) {
      //   this.$router.push("/assessment");

      //   document.documentElement.scrollTop = 0;
      // }
      if (index == 12) {
        this.$router.push("/guanyu");

        document.documentElement.scrollTop = 0;
      }

      if (index == 9) {
        this.$router.push("/personal");

        document.documentElement.scrollTop = 0;
      }

      if (index == 10) {
        this.$router.push("/login");

        document.documentElement.scrollTop = 0;
      }
      if (index == 19) {
        this.$router.push("/denglu");

        document.documentElement.scrollTop = 0;
      }
      if (index == 20) {
        this.$confirm("是否退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("retoken");
            localStorage.clear();
            this.$message({
              type: "success",
              message: "退出登录成功!",
            });
            this.$router.push("/denglu");
          })
          .catch(() => {});
      }
    },
    qie(id) {
      if (id == 1) {
        this.$refs.qiehuan.prev();
      }
      if (id == 2) {
        this.$refs.qiehuan.next();
      }
    },
    content() {
      let data = {
        params: {
          userId: this.id,
          pageNo: 1,
          pageSize: 6,
          // status: 3,
        },
      };
      news(data).then((res) => {
        if (res.status == 200) {
          // console.log(res);
          // this.lunbo = res.data.data.list;
          this.xw = res.data.data.list;
          ////console.log(this.lunbo);
          for (let i = 0; i < this.xw.length; i++) {
            this.xw[i].yue = this.xw[i].releaseTime.slice(5, 7);
            this.xw[i].ri = this.xw[i].releaseTime.slice(8, 10);
            // console.log(this.xw);
          }
        }
      });
      let da = {
        params: {
          userId: this.id,
          pageNo: 1,
          pageSize: 5,
          status: 3,
        },
      };
      news(da).then((res) => {
        if (res.status == 200) {
          // console.log(res);
          this.lunbo = res.data.data.list;
          // this.xw = this.lunbo.slice(0, 3);
          ////console.log(this.lunbo);
          for (let i = 0; i < this.lunbo.length; i++) {
            this.lunbo[i].yue = this.lunbo[i].releaseTime.slice(5, 7);
            this.lunbo[i].ri = this.lunbo[i].releaseTime.slice(8, 10);
          }
        }
      });
      let dat = {
        params: {
          userId: this.id,
          pageNo: 1,
          pageSize: 6,
          status: 4,
        },
      };
      news(dat).then((res) => {
        if (res.status == 200) {
          ////console.log(res);
          this.tong = res.data.data.list;
          for (let i = 0; i < this.tong.length; i++) {
            this.tong[i].yue = this.tong[i].releaseTime.slice(5, 7);
            this.tong[i].ri = this.tong[i].releaseTime.slice(8, 10);
          }
        }
      });
      let datas = {
        params: {
          userId: this.id,
          pageNo: 1,
          pageSize: 7,
          regLevel: "国家",
        },
      };
      lationWeb(datas).then((res) => {
        if (res.status == 200) {
          // ////console.log(res);
          this.ze = res.data.data.list;
        }
      });
      shoushu().then((res) => {
        // console.log(res);
        this.yiqi = res.data.data;
      });
      let datass = {
        params: {
          userId: this.id,
          pageNo: 1,
          pageSize: 10,
          status: 6,
        },
      };
      news(datass).then((res) => {
        if (res.status == 200) {
          // ////console.log(res);

          this.pingtai = res.data.data.list;
        }
      });
      let datasss = {
        params: {
          userId: this.id,
          pageNo: 1,
          pageSize: 10,
          status: 2,
        },
      };
      news(datasss).then((res) => {
        if (res.status == 200) {
          ////console.log(res);

          this.youq = res.data.data.list;
        }
      });
      fenlei().then((res) => {
        this.phoneData1 = res.data.data;
      });
      // ////console.log(this.xueguan);
      xueke(this.xueguan).then((res) => {
        // console.log(res, "111111111111111");
        this.phoneData2 = res.data.data;
      });
      linyu().then((res) => {
        // ////console.log(res);
        this.phoneData3 = res.data.data;
      });

      let yidata = {
        params: {
          pageNo: 1,
          pageSize: 8,
        },
      };
      yiqi(yidata).then((res) => {
        if (res.status == 200) {
          //console.log(res);
          this.copybasic = res.data.data.list;
        }
      });
    },
    xwdome(item, index) {
      // ////console.log(id);
      this.$router.push(`/newdetails?gid=${item.id}&biao=${index}`);
      document.documentElement.scrollTop = 0;
    },
    tzdome(item) {
      // ////console.log(id);
      this.$router.push("/notice?gid=" + item.id);
      document.documentElement.scrollTop = 0;
    },
    dian(id) {
      let a = document.getElementsByClassName("dian1")[0];
      let b = document.getElementsByClassName("dian2")[0];
      if (id == 1) {
        a.style.color = "#204289";
        b.style.color = "#ccc";
        this.b = 1;
        this.content();
      }
      if (id == 2) {
        a.style.color = "#ccc";
        b.style.color = "#204289";
        this.b = 2;
        let dat = {
          params: {
            userId: this.id,
            pageNo: 1,
            pageSize: 6,
            status: 4,
          },
        };
        news(dat).then((res) => {
          if (res.status == 200) {
            // ////console.log(res);
            this.tong = res.data.data.list;

            for (let i = 0; i < this.tong.length; i++) {
              this.tong[i].yue = this.tong[i].releaseTime.slice(5, 7);
              this.tong[i].ri = this.tong[i].releaseTime.slice(8, 10);
            }
          }
        });
      }
    },
    jians() {
      this.$message("正在建设中");
    },
    xiangqing(item) {
      this.$router.push("/Instrumentdetails?gid=" + item.id).then(() => {
        // 重新刷新页面
        location.reload();
      });

      document.documentElement.scrollTop = 0;
    },
    lei(id) {
      // console.log(id);
      this.$router.push({ name: "yiqiliebiao", params: { lei: id } });
      sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      document.documentElement.scrollTop = 0;
    },
    xue(id) {
      // console.log(id);
      this.$router.push({ name: "yiqiliebiao", params: { xue: id } });
      sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      document.documentElement.scrollTop = 0;
    },
    chan(id) {
      // console.log(id);
      this.$router.push({ name: "yiqiliebiao", params: { chan: id } });
      sessionStorage.setItem("insuranceCode", JSON.stringify(3));
      document.documentElement.scrollTop = 0;
    },
    xiang(item, index) {
      // console.log(item);

      this.$router
        .push(`/evaxiang?gid=${item.regId}&biao=${index}`)
        .then(() => {
          // 重新刷新页面
          location.reload();
        });

      document.documentElement.scrollTop = 0;
    },
    ping(id) {
      if (id == 0) {
        this.$router.push("/pingtai");
        sessionStorage.setItem("insuranceCode", JSON.stringify(7));
        document.documentElement.scrollTop = 0;
      }
      if (id != 0) {
        this.$router.push({ name: "fence", params: { id: id } });
        sessionStorage.setItem("insuranceCode", JSON.stringify(7));
        document.documentElement.scrollTop = 0;
      }
    },
    ying() {
      this.p = false;
    },
    wai() {
      this.$confirm("您访问的链接即将离开当前页面，是否继续？", "友情提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning", // 可选，用于显示警告类型的对话框
      })
        .then(() => {
          // 用户点击了“确定”按钮
          window.open("https://irshare.cn/Sz_yqmh/", "_blank");
        })
        .catch(() => {
          // 用户点击了“取消”按钮
          // 这里可以处理取消操作，或者什么也不做
          // console.log("用户取消了操作");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  margin: 0 auto 50px;
  position: relative;
  height: 600px;
  // width: 1920px;
  // display: flex;
  // width: 1200px;
  // margin: 0 auto 50px;
  // min-width: 300%;
  background-image: url(../assets/di.png);
  background-size: 100% 100%;
}

@media screen and (max-width: 400px) {
  .top {
    margin: 0 auto 50px;
    position: relative;
    height: 987px;
    width: 1200px;

    background-color: #fff;
    // min-width: 300%;
    background-image: url(../assets/di.png);
    background-size: 100% 100%;
  }
  .logo {
    display: flex;
    img {
      width: 51px;
      height: 54px;
      // margin-right: 20px;
    }
    div {
      width: 110px;
      div {
        margin-left: 10px;
        margin-top: 7px;
        margin-bottom: 8px;
        font-family: Source-KeynoteartHans;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 16px;
      }
    }
  }
  .daohang {
    position: absolute;
    // margin-top: 12px;
    // margin-left: 12px;
    left: -130px;
    top: 120px;
    span {
      margin-right: 5px;
      width: 20px;

      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      line-height: 16px;
      opacity: 0.8;
      cursor: pointer;
    }
    .xian {
      padding-bottom: 10px;
      border-bottom: 1px solid #fff;
    }
  }

  .kuaizi {
    // margin-top: 1000px;
    margin-left: 14px;
    .zishang {
      font-weight: bold;
      font-size: 12px;
      line-height: 60px;
      color: #666666;
    }
    .zixia {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #999999;
    }
  }
}

.shang {
  margin: 0 auto;
  display: flex;
  padding: 0 30px;
  background: rgba(0, 0, 0, 0.3);
  height: 60px;

  // width: 100%;

  .logo {
    display: flex;
    img {
      margin-top: 3px;
      width: 51px;
      height: 54px;
      margin-right: 30px;
      // opacity: 0.5;
    }
    div {
      line-height: 60px;
      // width: 110px;
      div {
        margin-top: 18px;
        margin-bottom: 8px;
        font-family: Source-KeynoteartHans;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 16px;
      }
    }
  }

  .tiaoz {
    position: absolute;
    right: 25px;
    margin-top: 12px;

    display: flex;
    .zuo {
      margin-right: 30px;
      width: 104px;
      height: 33px;
      line-height: 34px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      border-radius: 15px;
      border: 1px solid #ffffff;
      cursor: pointer;
      a {
        text-decoration: none;
        color: #fff;
      }
    }
    .you {
      width: 104px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      font-size: 16px;
      color: #2564ff;
      background: #ffffff;
      border-radius: 15px;
      cursor: pointer;
    }
  }
}
.biaoti {
  // position: absolute;
  // left: 18%;
  // top: 19%;
  width: 1350px;
  // margin: 65px auto 0;
  margin: 100px auto 0;
  text-align: center;
  div {
    // width: 760px;
    font-size: 60px;
    font-family: Source-KeynoteartHans;
    font-weight: 400;

    color: #ffffff;
  }
}
::v-deep.sousuo {
  // position: absolute;
  // left: 23.5%;
  // top: 54%;
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  .ssdi {
    margin-left: 150px;

    padding-top: 1px;
    width: 870px;
    height: 60px;

    background: rgba(255, 255, 255, 0.45);
    border-radius: 40px;
    // border: 1px solid #3773f5;
    // opacity: 0.45;
    .search {
      position: relative;

      display: flex;
      width: 843px;
      height: 45px;

      background: #ffffff;
      border-radius: 60px;
      margin: 8px auto 0;
      .xiala {
        width: 150px;
        height: 61px;

        .el-input__inner {
          padding-left: 45px;
          height: 45px;
          border-radius: 31px;
          // background-color: red;
          border: none;
          font-size: 18px;
          font-family: Source Han Sans CN;
          // opacity: 0.8;
          font-weight: 700;
          color: rgba(0, 0, 0, 0.5);
        }
        input::placeholder {
          font-weight: 700;
          color: rgba(0, 0, 0, 0.5);
          font-family: Source Han Sans CN;
          // opacity: 0.8;
        }
      }
      .shu {
        position: absolute;
        left: 170px;
        top: 8px;
        width: 1px;

        height: 31px;
        background: #cdcdcd;
        border-radius: 0px;
        opacity: 0.71;
      }
      .inp {
        position: absolute;
        left: 190px;
        // top: 15px;

        height: 45px;
        width: 600px;
        border: none;
        font-size: 16px;
        // background-color: red;
      }
      input[type="text"]:focus {
        outline: none;
      }
      input::placeholder {
        font-family: Source Han Sans CN;
        color: rgba(0, 0, 0, 0.44);
      }
      .anniu {
        position: absolute;

        right: 0;

        width: 107px;
        height: 45px;
        // background: #3773f5;
        background: #00cc99;
        border-radius: 30px;
        // border: 1px solid #00cc99;
        text-align: center;
        cursor: pointer;
        img {
          margin-top: 8px;
          width: 30px;
          height: 30px;
          // font-size: 30px;

          color: #fff;
        }
      }
    }
  }
}
.taiojian {
  display: flex;
  // position: absolute;
  // left: 27%;
  // top: 50%;
  width: 1200px;
  margin: 60px auto 16px;
  text-align: center;
  img {
    margin-top: 5px;
    margin-left: 200px;
    width: 16px;
    height: 19px;
  }

  p {
    margin-left: 15px;

    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
  }
  span {
    margin-left: 15px;

    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
  }
}
.daohang {
  display: flex;
  margin: 60px auto 0;
  width: 1200px;
  height: 80px;
  background: #d1e5ff;
  border-radius: 5px;
  justify-content: space-evenly;
  span {
    line-height: 80px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    cursor: pointer;
    span {
      padding-bottom: 5px;
      border-bottom: 2px solid #000;
    }
  }
}
.zhanshi {
  display: flex;
  // position: absolute;
  // left: 27%;
  // bottom: 89px;
  margin: 88px auto 0;
  text-align: center;
  padding: 0 10px;
  width: 849px;
  height: 186px;

  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;

  .kuai {
    display: flex;
    margin: 30px 10px;
    width: 260px;
    height: 130px;

    background: #e6f1ff;
    border-radius: 10px;
    img {
      margin-left: 31px;
      margin-top: 30px;

      width: 70px;
      height: 70px;
    }
    .kuaizi {
      margin-top: 20px;
      margin-left: 14px;
      .zishang {
        font-weight: bold;
        font-size: 42px;
        // line-height: 60px;
        color: #666666;
      }
      .zixia {
        font-weight: 400;
        font-size: 16px;
        // line-height: 20px;
        color: #999999;
      }
    }
  }
  .kxian {
    margin-top: 30px;
    width: 3px;
    height: 53px;
    background: #969696;
    border-radius: 2px;
    opacity: 0.17;
  }
}
.tongzi {
  display: flex;
  margin: 0 auto 30px;
  width: 1200px;
  height: 100px;
  background: #d1e5ff;
  position: relative;
  .tongle {
    span {
      position: absolute;
      top: 15px;
      left: 39px;
      width: 80px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 27px;
      color: #d92009;
      z-index: 15;
    }
    img {
      left: 11px;
      top: -1px;
      position: absolute;
      width: 120px;
      height: 101px;
    }
  }
  .tongri {
    position: absolute;
    right: 50px;

    .ritop {
      margin: 20px 0 10px 0;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 26px;
      color: #333333;
      width: 1000px;
      overflow: hidden;
      text-overflow: ellipsis;
      /* 将对象作为弹性伸缩盒子模型显示 */
      display: -webkit-box;
      /* 限制在一个块元素显示的文本的行数 */
      /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
      -webkit-line-clamp: 1;
      /* 设置或检索伸缩盒对象的子元素的排列方式 */
      -webkit-box-orient: vertical;
    }
    .ribot {
      display: flex;
      cursor: pointer;
      div {
        margin-right: 30px;
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        /* 将对象作为弹性伸缩盒子模型显示 */
        display: -webkit-box;
        /* 限制在一个块元素显示的文本的行数 */
        /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
        -webkit-line-clamp: 1;
        /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-box-orient: vertical;
      }
    }
  }
  .tongimg {
    position: absolute;
    right: 20px;
    bottom: 10px;
    cursor: pointer;
    img {
      width: 20px;
      height: 10px;
    }
  }
}

::v-deep.main {
  display: flex;
  width: 1200px;
  margin: 60px auto 50px;
  // margin: 0 360px 50px;
  .tongzi {
    width: 1200px;
    height: 100px;
    background: #d1e5ff;
    position: relative;
  }
  .lunbo {
    position: relative;
    width: 635px;
    height: 395px;
    // background: #969696;
    border-radius: 5px;
    background-size: 100% 100%;
    img {
      display: block;
      width: 635px;
      height: 395px;
      border-radius: 5px;
      object-fit: cover;
      background-size: 100% 100%;
    }
    .el-carousel__indicator--horizontal {
      display: none;
    }
    .el-carousel__container {
      height: 395px;
    }
    .lundi {
      display: flex;
      position: absolute;
      bottom: 0;
      width: 635px;
      height: 40px;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.45);
      border-radius: 0px 0px 5px 5px;
      div {
        margin: 0 15px;
      }
      .lunzi {
        width: 400px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #fff;
      }
      .lunzuo {
        margin-left: 30px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
      .lunjing {
        font-size: 14px;
        color: #fff;
      }
      .lunyou {
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .xw {
    width: 500px;
    height: 351px;
    padding: 23px 35px 21px 30px;
    background: #ffffff;
    box-shadow: 1px 2px 15px 0px rgba(80, 80, 80, 0.3);
    border-radius: 0px 10px 5px 0px;

    .xwtit {
      margin-bottom: 30px;
      position: relative;
      .titd {
        margin-right: 10px;
        margin-bottom: 2px;
        width: 13px;
        height: 10px;
      }
      .dian1 {
        color: #cccccc;
      }
      .dian2 {
        color: #204289;
      }
      span {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        cursor: pointer;
      }

      .titt {
        position: absolute;
        right: 0;
        top: 8px;
        width: 21px;
        height: 12px;
        cursor: pointer;
      }
    }
    .xwtime {
      text-align: center;
      .ri {
        font-weight: bold;
        font-size: 16px;
        color: #3e7af6;
      }
      .yue {
        display: flex;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }
    }
    .xwxian {
      margin: 0 13px;
      position: relative;
      .xwxiany {
        font-size: 12px;
      }
      .xwxianx {
        position: absolute;
        top: 15px;
        left: 7px;
        width: 1px;
        height: 40px;
        background: #e4e4e4;
      }
    }
    .xwlie {
      display: flex;
      width: 450px;
      height: 50px;
      // margin-bottom: 10px;
      .xwbiao {
        cursor: pointer;
        .xwbaiotit {
          margin-bottom: 14px;
          font-family: Source Han Sans CN;
          font-weight: 700;
          font-size: 16px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 1;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
        }
        .xwbaionei {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 19px;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 3;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
.zhong {
  width: 1200px;
  margin: 60px auto 0;
  display: flex;
  justify-content: space-between;
  div {
    position: relative;
    .rou {
      position: absolute;
      top: 33px;
      left: 27px;
      .shu {
        font-family: Digital-7;
        font-weight: 400;
        font-size: 40px;
        color: #204289;
        line-height: 18px;
        font-style: italic;
      }
      .zhi {
        margin-top: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }
    }
  }
}
.yewu {
  display: flex;
  margin-left: 30px;
  width: 1200px;
  height: 370px;

  margin: 46px auto 30px;
  // background: #ffffff;
  // box-shadow: 1px 2px 15px 0px rgba(80, 80, 80, 0.3);
  // border-radius: 5px;
  .yewutop {
    position: relative;
    display: flex;
    width: 170px;
    height: 90px;
    line-height: 90px;
    letter-spacing: 2px;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    opacity: 0.79;
    border-radius: 5px 0px 0px 5px;
    // background-image: url(../assets/yewutop.png);
    background: #0066ff;
    span {
      position: absolute;
      top: 2px;
      left: 30px;
    }
    div {
      position: absolute;
      right: 20px;
      top: 40px;
      width: 23px;
      height: 14px;
      background: #ffffff;
      border-radius: 7px;
      div {
        position: absolute;
        right: 2px;
        top: 2px;

        width: 10px;
        height: 10px;
        background: #0052d9;
        border-radius: 50%;
      }
    }
  }
  .left {
    width: 580px;
  }
  .yewuxia {
    display: flex;
    a {
      text-decoration: none;
    }
    div {
      margin-right: 34px;
      margin-bottom: 33px;
      width: 170px;
      height: 170px;
      background: #f1f7ff;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      img {
        margin: 40px auto 27px;
        width: 56px;
        height: 56px;
      }
      p {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
      }
    }
    div:nth-child(3n) {
      margin-right: 0;
    }
  }
  .right {
    .lianle {
      position: relative;
      margin-left: 42px;
      width: 582px;
      height: 370px;
      // background-image: url(../assets/lianjie.png);
      background: #f0f0f0;
      border-radius: 5px;
      .lianletop {
        margin: 0 27px 16px 22px;
        padding-top: 31px;
        position: relative;
        .lianled {
          margin-bottom: 2px;
          margin-right: 10px;
          width: 13px;
          height: 10px;
        }
        span {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #204289;
        }
        .lianlet {
          position: absolute;
          right: 0;
          top: 39px;
          width: 21px;
          height: 12px;
          cursor: pointer;
        }
      }
      .zhengc {
        position: relative;
        margin-left: 25px;

        span {
          position: absolute;
          top: 10px;
          width: 3px;
          height: 3px;

          background: #cccccc;
          border-radius: 50%;
        }
        a {
          width: 498px;
          margin-left: 40px;
          margin-bottom: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 1;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .yiqi {
  // width: 1920px;
  height: 850px;
  background: #f0f0f0;
  border-radius: 0px;

  .juz {
    width: 1200px;
    margin: 0 auto;
    .yitop {
      padding-top: 32px;
      margin-bottom: 27px;
      span {
        margin-left: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #204289;
      }
      .yyy {
        float: right;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
      }
    }
  }
  .yilie {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .yizuo {
      width: 180px;
      height: 685px;
      // padding-top: 10px;
      // background: #ffffff;

      .yu {
        width: 165px;
        height: 50px;
        background-image: url(../assets/yu.png);
        margin-bottom: 7px;
        // text-align: center;
        padding-left: 15px;
        line-height: 50px;
        font-size: 24px;
        color: #2b6cf5;
        cursor: pointer;
      }
      .el-collapse {
        border-radius: 5px;
        background-image: url(../assets/yidi.png);
      }
      .el-collapse {
        border-top: none;
        border-bottom: none;
      }
      .el-collapse-item__header {
        margin-left: 18px;
        color: #fff;
        background: none;
        border-bottom: none;
        font-size: 18px;
      }
      .el-collapse-item__wrap {
        color: #fff;
        background: none;
        border-bottom: none;
        div {
          margin-right: 16px;
          margin-left: 17px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
        div:hover {
          color: red;
        }
      }
      .el-collapse-item__content {
        height: 460px;
        overflow-y: auto;
        flex-wrap: wrap;
        div {
          // line-height: 30px;
          margin-bottom: 20px;
        }
      }
      .el-collapse-item__content::-webkit-scrollbar {
        width: 2px;
        height: 1px;
        // background-color: red;
      }
      .el-collapse-item__content::-webkit-scrollbar-thumb {
        width: 1px;
        height: 1px;
        background-color: #ffffff;
      }
    }
    .yiyou {
      position: relative;
      margin-left: 30px;
      .yous {
        width: 990px;

        .youge {
          margin-left: 24px;
          float: left;
          width: 223px;
          margin-bottom: 23px;
          cursor: pointer;

          img {
            width: 223px;
            height: 223px;
            margin-bottom: 10px;
          }
          .name {
            font-size: 16px;
            color: #2e8ce3;
            margin-bottom: 5px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .xing {
            font-size: 14px;
            color: #333333;
            margin-bottom: 5px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .lei {
            font-size: 14px;
            color: #333333;
            margin-bottom: 5px;
            width: 180px;
            overflow: hidden; /* 隐藏溢出的内容 */
            white-space: nowrap; /* 防止文本换行 */
            text-overflow: ellipsis; /* 显示省略号 */
          }
          .biao {
            color: red;
            line-height: 13px;
            span {
              margin-left: 3px;
              display: inline-block;
              width: 180px;
              font-size: 14px;
              color: #333333;
              overflow: hidden; /* 隐藏溢出的内容 */
              white-space: nowrap; /* 防止文本换行 */
              text-overflow: ellipsis; /* 显示省略号 */
            }
          }
        }
        // .youge:nth-child(4) {
        //   margin-left: 0px;
        // }
      }
      .youx {
        position: absolute;
        bottom: 0;
        width: 990px;
        height: 45px;
        background: #ffffff;
        border-radius: 5px;
        text-align: center;
        line-height: 45px;
        font-size: 24px;
        color: #2b6cf5;
        cursor: pointer;
      }
    }
  }
}
.shes {
  // width: 1920px;
  height: 400px;
  // background: #f0f0f0;
  margin-bottom: 60px;
  .juz {
    width: 1200px;
    margin: 0 auto;

    .shestop {
      padding-top: 32px;
      // margin-bottom: 27px;
      span {
        margin-left: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #204289;
      }
    }
    .sheslie {
      display: flex;
      justify-content: space-around;
      background: none !important;
      button {
        background: none !important;
      }
      .ge {
        margin-top: 30px;
        width: 380px;
        height: 270px;
        background: #ffffff;
        border-radius: 5px;
        text-align: center;
        img {
          margin-top: 20px;
        }

        a {
          text-decoration: none;
        }
        div {
          margin-top: 6px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
      }
    }
  }
}
::v-deep .z {
  background: none;
}
::v-deep .y {
  background: none;
}
.zaixian {
  // width: 1920px;
  height: 410px;
  background: #d1e5ff;
  border-radius: 0px;
  .juz {
    width: 1200px;
    margin: 0 auto;
    .zaitop {
      padding-top: 32px;
      margin-bottom: 27px;
      span {
        margin-left: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #204289;
      }
    }
    .zailie {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      // justify-content: stretch;
      .rrr {
        margin-right: 40px;
        margin-bottom: 35px;
        width: 270px;
        height: 100px;
        background: #ffffff;
        border-radius: 5px;
        cursor: pointer;
        a {
          display: flex;
          text-decoration: none;
          position: relative;
          img {
            margin: 15px 0 0 21px;
            width: 67px;
            height: 67px;
          }
          .zainame {
            margin-top: 30px;
            margin-left: 16px;
            // line-height: 100px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 24px;
            color: #374567;
          }
          .zainame2 {
            margin-top: 15px;
            margin-left: 16px;
            // line-height: 100px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 24px;
            color: #374567;
          }
        }
      }
      .rrr:nth-child(4n) {
        margin-right: 0;
      }
      .zaitaio {
        width: 270px;
        height: 100px;
        background: #f0f0f0;
        border-radius: 5px;
        text-align: center;
        line-height: 100px;
        cursor: pointer;
      }
    }
  }
}
.lianjie {
  display: flex;
  width: 1200px;
  margin: 53px auto 50px;
  // margin: 0 360px 50px;

  .lianrig {
    width: 1200px;
    // height: 230px;
    // background-image: url(../assets/lianjie.png);
    background: #f0f0f0;
    border-radius: 5px;
    .lianrigtop {
      margin: 21px 27px 16px 22px;
      position: relative;
      .lianrigd {
        margin-bottom: 2px;
        margin-right: 10px;
        width: 13px;
        height: 10px;
      }
      span {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #204289;
      }
      .lianrigt {
        position: absolute;
        right: 0;
        top: 8px;
        width: 21px;
        height: 12px;
      }
    }
    .youlie {
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      .yyy {
        margin-right: 30px;
        margin-bottom: 26px;
        padding-right: 17px;
        // height: 41px;
        background: #ffffff;
        box-shadow: 1px 2px 10px 0px rgba(179, 179, 179, 0.3);
        border-radius: 5px;
        a {
          text-decoration: none;
          display: flex;
          img {
            margin: 14px 0 0 17px;
            width: 30px;
            height: 17px;
          }
          .youzi {
            margin-left: 15px;
            line-height: 41px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // /* 将对象作为弹性伸缩盒子模型显示 */
            // display: -webkit-box;
            // /* 限制在一个块元素显示的文本的行数 */
            // /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
            // -webkit-line-clamp: 2;
            // /* 设置或检索伸缩盒对象的子元素的排列方式 */
            // -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}

.piao {
  width: 301px;
  height: 98px;
  position: fixed; /* 使元素相对于视口固定 */
  right: 0px; /* 距离视口右侧20px */
  top: 70%; /* 垂直居中，可以根据需要调整 */
  transform: translateY(-50%); /* 垂直居中调整 */
  z-index: 1000; /* 确保悬浮窗位于其他内容之上 */
  background-image: url(../assets/piao.png);
  cursor: pointer;
  div {
    float: right;
    margin-right: 18px;
    margin-top: 10px;
    width: 25px;
    height: 25px;
    // background-color: #fff;
    cursor: pointer;
  }
}
</style>
